import { render, staticRenderFns } from "./AgreementsList.vue?vue&type=template&id=4b54732f&"
import script from "./AgreementsList.vue?vue&type=script&lang=js&"
export * from "./AgreementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports